import React from 'react';
import { Route, Switch } from 'react-router';
import RouteGetter from '../../../routes/RouteGetter';
import ProjectOrdersPage from './ProjectOrdersPage';
import ProjectOrderPage from './ProjectOrderPage';

const ProjectOrdersRoute = () => (
  <Switch>
    <Route exact path={RouteGetter.get('project').ordersPath()}>
      <ProjectOrdersPage />
    </Route>
    <Route exact path={RouteGetter.get('project').orderPath()}>
      <ProjectOrderPage />
    </Route>
  </Switch>
);

export default ProjectOrdersRoute;
